import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

type Props = {
  eyebrow: string;
  title: string;
  highlight?: string;
  intro?: string;
};

/** Black masthead used at the top of every inner page. */
export default function PageHero({ eyebrow, title, highlight, intro }: Props) {
  return (
    <section className="relative overflow-hidden" style={{ background: 'var(--color-ink)' }}>
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '20px 20px',
        }}
        aria-hidden="true"
      />
      <div className="relative max-w-screen-xl mx-auto px-5 md:px-8 py-10 md:py-14">
        <nav
          className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-white/50"
          aria-label="Breadcrumb"
        >
          <Link to="/" className="hover:text-white transition-colors">Home</Link>
          <ChevronRight size={12} />
          <span style={{ color: 'var(--color-yellow)' }}>{eyebrow}</span>
        </nav>

        <h1 className="mt-4 display text-4xl md:text-6xl text-white rule-gold">
          {title}
          {highlight && (
            <>
              {' '}
              <span style={{ color: 'var(--color-yellow)' }}>{highlight}</span>
            </>
          )}
        </h1>

        {intro && (
          <p className="mt-6 max-w-xl text-sm md:text-[15px] text-white/70 leading-relaxed">{intro}</p>
        )}
      </div>
    </section>
  );
}
